export const getUser = (location=window.location) => {
  return /^(?:\/vod)?\/([^/]+)/.exec(location.pathname)[1]
};
